import React from 'react'
import {API_URL} from '../../../config/const'

export default function TableCellGameCate(props) {
  return (
    <div className={'d-center ' + props.className}>
      { props.icon &&
        props.icon.split(',').map((it, idx) => {return <img key={idx} className='' src={API_URL + '/assets/image/' + it} alt='' width={22} height={22}/>})
      }
      { !props.icon &&
        <div className={'fs-14 sm-fs-12 f-m color-3a3335 mt-2'}>{props.name}</div>
      }
    </div>
  )
}